var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { toCamelCase } from "@domains/utils/stringMethods";
export var addDashIfZero = function (value) {
    var newValue;
    if (value === 0) {
        newValue = "-";
    }
    else {
        newValue = value === null || value === void 0 ? void 0 : value.toString();
    }
    return newValue;
};
export var addDashForFalsyValue = function (value, showNA) {
    if (showNA === void 0) { showNA = false; }
    return !!value &&
        value !== "0" &&
        value !== "0.00" &&
        value !== "null" &&
        value !== "--" &&
        value !== null
        ? value === null || value === void 0 ? void 0 : value.toString()
        : showNA
            ? "NA"
            : "-";
};
export var addDashIfNullOrUndefined = function (value) {
    var newValue;
    if (value === "" ||
        value === undefined ||
        value == null ||
        value === "-" ||
        value === " ") {
        newValue = "-";
    }
    else {
        newValue = value === null || value === void 0 ? void 0 : value.toString();
    }
    return newValue;
};
export var checkValue = function (n) {
    if (n === "" || n === undefined || n === null || n === "-") {
        return "--";
    }
    return n;
};
export var roundUpToTwoDecimalPlaces = function (value) {
    var newValue = value === null || value === void 0 ? void 0 : value.toString();
    if (value !== 0)
        newValue = value === null || value === void 0 ? void 0 : value.toFixed(2);
    if (Number === null || Number === void 0 ? void 0 : Number.isNaN(value))
        return "-";
    return newValue;
};
export var roundOffWithZeros = function (value) {
    var newValue = value.toString();
    if (value !== undefined && value !== null)
        newValue = value.toFixed(2).toString();
    return newValue;
};
export var addCommas = function (n, showZero, defaultVal, maximumFractionDigits) {
    if (n !== null &&
        n !== undefined &&
        n !== "" &&
        n !== "-" &&
        n !== "--" &&
        n !== "null") {
        if (typeof n === "number") {
            if (Number(n) === 0 && (showZero === undefined || showZero === false)) {
                return defaultVal ? defaultVal : "-";
            }
            return n.toLocaleString("en-IN", {
                maximumFractionDigits: maximumFractionDigits
                    ? maximumFractionDigits
                    : 2,
                minimumFractionDigits: 2,
            });
        }
        if (typeof n === "string") {
            //to check summarized values
            if (n.slice(-1) === "K" || n.slice(-1) === "L" || n.slice(-2) === "Cr") {
                return n;
            }
            else {
                if ((n === "0" || Number(n) === 0) &&
                    (showZero === undefined || showZero === false)) {
                    return defaultVal ? defaultVal : "-";
                }
                return Number(n).toLocaleString("en-IN", {
                    maximumFractionDigits: maximumFractionDigits
                        ? maximumFractionDigits
                        : 2,
                    minimumFractionDigits: 2,
                });
            }
        }
    }
    else {
        return defaultVal ? defaultVal : "-";
    }
};
export var addCommasWithoutEffectingDecimals = function (n) {
    if (n === null || n === undefined || isNaN(Number(n))) {
        return "-";
    }
    var numericValue = parseFloat(n.toString());
    var decimalPart = n.toString().split(".")[1];
    return numericValue.toLocaleString("en-IN", {
        minimumFractionDigits: decimalPart ? decimalPart.length : 0,
        maximumFractionDigits: decimalPart ? decimalPart.length : 0,
    });
};
export var addCommasWithoutDecimal = function (n, showZero, defaultVal, maximumFractionDigits) {
    var result = addCommas(n, showZero, defaultVal, maximumFractionDigits);
    return result !== "-" ? result.split(".")[0] : result;
};
export var validateVal = function (val) {
    return val && (val === "" || val === "-" || val === "--");
};
export var validateisNumber = function (evt) {
    //Float validation
    var ASCIICode = evt.which ? evt.which : evt.keyCode;
    if (ASCIICode != 190 && ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
        return evt.preventDefault();
    return true;
};
export var roundUpTonDecimals = function (n, val, showZero, defaultVal) {
    var _a;
    var newValue = parseFloat(val);
    if (showZero && newValue === 0)
        return (_a = Number(val)) === null || _a === void 0 ? void 0 : _a.toFixed(n);
    else {
        if (Number.isNaN(newValue))
            return defaultVal ? defaultVal : "-";
    }
    return addCommas(newValue === null || newValue === void 0 ? void 0 : newValue.toFixed(n), showZero, defaultVal);
};
export var addCommasWithConditionalDecimal = function (n, showZero, defaultVal) {
    var result = addCommas(n, showZero, defaultVal);
    if (result !== "-" && +result.split(".")[1] == 0) {
        return result.split(".")[0];
    }
    else {
        return result;
    }
};
var a = [
    "",
    "one ",
    "two ",
    "three ",
    "four ",
    "five ",
    "six ",
    "seven ",
    "eight ",
    "nine ",
    "ten ",
    "eleven ",
    "twelve ",
    "thirteen ",
    "fourteen ",
    "fifteen ",
    "sixteen ",
    "seventeen ",
    "eighteen ",
    "nineteen ",
];
var b = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
];
export var inWords = function (num) {
    if ((num = num.toString()).length > 11)
        return "overflow";
    var n = ("00000000000" + num)
        .substr(-11)
        .match(/^(\d{1})(\d{1})(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n)
        return;
    var str = "";
    str +=
        n[1] != 0
            ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "thousand "
            : "";
    str +=
        n[2] != 0
            ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "hundred "
            : "";
    str +=
        n[3] != 0
            ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "crore "
            : "";
    str +=
        n[4] != 0
            ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "lakh "
            : "";
    str +=
        n[5] != 0
            ? (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) + "thousand "
            : "";
    str +=
        n[6] != 0
            ? (a[Number(n[6])] || b[n[6][0]] + " " + a[n[6][1]]) + "hundred "
            : "";
    str +=
        n[7] != 0
            ? (str != "" ? "and " : "") +
                (a[Number(n[7])] || b[n[7][0]] + " " + a[n[7][1]])
            : //+"only "
                "";
    return toCamelCase(str);
};
export var inWordsWithDecimal = function (num) {
    if (isNaN(Number(num)))
        return "Invalid number";
    var _a = __read(num.toString().split("."), 2), integerPart = _a[0], decimalPart = _a[1];
    if (integerPart.length > 11)
        return "overflow";
    var n = ("00000000000" + integerPart)
        .slice(-11)
        .match(/^(\d{1})(\d{1})(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n)
        return;
    var str = "";
    str +=
        Number(n[1]) != 0
            ? (a[Number(n[1])] || b[Number(n[1][0])] + " " + a[Number(n[1][1])]) +
                " thousand "
            : "";
    str +=
        Number(n[2]) != 0
            ? (a[Number(n[2])] || b[Number(n[2][0])] + " " + a[Number(n[2][1])]) +
                " hundred "
            : "";
    str +=
        Number(n[3]) != 0
            ? (a[Number(n[3])] || b[Number(n[3][0])] + " " + a[Number(n[3][1])]) +
                " crore "
            : "";
    str +=
        Number(n[4]) != 0
            ? (a[Number(n[4])] || b[Number(n[4][0])] + " " + a[Number(n[4][1])]) +
                " lakh "
            : "";
    str +=
        Number(n[5]) != 0
            ? (a[Number(n[5])] || b[Number(n[5][0])] + " " + a[Number(n[5][1])]) +
                " thousand "
            : "";
    str +=
        Number(n[6]) != 0
            ? (a[Number(n[6])] || b[Number(n[6][0])] + " " + a[Number(n[6][1])]) +
                " hundred "
            : "";
    str +=
        Number(n[7]) != 0
            ? (str !== "" ? "and " : "") +
                (a[Number(n[7])] || b[Number(n[7][0])] + " " + a[Number(n[7][1])])
            : "";
    if (decimalPart) {
        var decimalWords = decimalPart
            .split("")
            .map(function (digit) { return a[Number(digit)]; })
            .join(" ");
        str += " point " + decimalWords;
    }
    return toCamelCase(str);
};
// export const inWords = (num: number | string) => {
//   if ((num = num.toString()).length > 9) return "overflow";
//   var n: any = ("000000000" + num)
//     .substr(-9)
//     .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
//   if (!n) return;
//   var str = "";
//   str +=
//     n[1] != 0
//       ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "crore "
//       : "";
//   str +=
//     n[2] != 0
//       ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "lakh "
//       : "";
//   str +=
//     n[3] != 0
//       ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand "
//       : "";
//   str +=
//     n[4] != 0
//       ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred "
//       : "";
//   str +=
//     n[5] != 0
//       ? (str != "" ? "and " : "") +
//         (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]])
//       : //+"only "
//         "";
//   return toCamelCase(str);
// };
export var numberWithSuffix = function (number) {
    var j = number % 10, k = number % 100;
    if (j == 1 && k != 11) {
        return number + "st";
    }
    if (j == 2 && k != 12) {
        return number + "nd";
    }
    if (j == 3 && k != 13) {
        return number + "rd";
    }
    return number + "th";
};
export var roundUpToFourDecimalPlaces = function (value) {
    var newValue = value === null || value === void 0 ? void 0 : value.toString();
    if (value !== 0)
        newValue = value === null || value === void 0 ? void 0 : value.toFixed(4);
    if (Number === null || Number === void 0 ? void 0 : Number.isNaN(value))
        return "-";
    return newValue;
};
export var roundUpToThreeDecimalPlaces = function (value) {
    var newValue = value === null || value === void 0 ? void 0 : value.toString();
    if (value !== 0)
        newValue = value === null || value === void 0 ? void 0 : value.toFixed(3);
    if (Number === null || Number === void 0 ? void 0 : Number.isNaN(value))
        return "-";
    return newValue;
};
export var addCommasWithConditionalDecimalWithNA = function (n, showZero, defaultVal) {
    if (!n)
        return defaultVal || "NA";
    var result = addCommas(n, showZero, defaultVal);
    if (result !== "-" && +result.split(".")[1] == 0) {
        return result.split(".")[0];
    }
    else {
        return result;
    }
};
export var addCommasWithNA = function (n, showZero, defaultVal, maximumFractionDigits) {
    if (n !== null && n !== undefined && n !== "" && n !== "-" && n !== "--") {
        if (typeof n === "number") {
            if (Number(n) === 0 && (showZero === undefined || showZero === false)) {
                return defaultVal ? defaultVal : "NA";
            }
            return n.toLocaleString("en-IN", {
                maximumFractionDigits: maximumFractionDigits
                    ? maximumFractionDigits
                    : 2,
                minimumFractionDigits: 2,
            });
        }
        if (typeof n === "string") {
            if (n.slice(-1) === "K" || n.slice(-1) === "L" || n.slice(-2) === "Cr") {
                return n;
            }
            else {
                if ((n === "0" || Number(n) === 0) &&
                    (showZero === undefined || showZero === false)) {
                    return defaultVal ? defaultVal : "NA";
                }
                return Number(n).toLocaleString("en-IN", {
                    maximumFractionDigits: maximumFractionDigits
                        ? maximumFractionDigits
                        : 2,
                    minimumFractionDigits: 2,
                });
            }
        }
    }
    else {
        return defaultVal ? defaultVal : "NA";
    }
};
export var removeTrailingZeros = function (value) {
    if (value && value.indexOf(".") > -1) {
        return value.replace(/\.?0+$/, "");
    }
    return value;
};
export var getDateSuffix = function (n) {
    var updatedNumber = Number(n);
    var suffixes = ["th", "st", "nd", "rd"];
    var v = updatedNumber % 100;
    var suffix = v >= 11 && v <= 13 ? "th" : suffixes[updatedNumber % 10] || "th";
    return "".concat(updatedNumber).concat(suffix);
};
